import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { templateFlightCart } from './Cart';
import { ExpiryTimeContext, ExpiryTimeCounter } from '../../utils/ExpiryTimeCounter';
import { Passengers } from '../TicketManagement/Flight/OrderDetail/Passengers';
import { getNumber, formatMoney } from '../../features/utils/formatMoney';
import { Flight } from '@mui/icons-material';
import Button1 from '../../components/form/Button1';
import { useNavigate } from 'react-router-dom';
import { URLdecode } from '../../utils/url';

export default function CartFlightConfirmation() {
    const {userData: {user}} = useSelector(state => state.user)
    const [carts, setCarts] = useState([]);
    const {status} = URLdecode()
    
    const lastBooking = carts?.at(-1)
    const expiry = lastBooking?.booking?.flightBooking?.at(0)?.ticketingExpiry;
    
    let bookedCarts = [];
    
    const navigate = useNavigate();
    
    useEffect(() => {
        loadCart();

        //eslint-disable-next-line
    },[])


    function loadCart() {
        let carts = JSON.parse(window.localStorage.getItem("flightCart") || "[]");
    
        carts = carts?.filter((obj) => !bookedCarts.includes(obj?.booking?._id));
        window.localStorage.setItem("flightCart", JSON.stringify(carts));
        if (carts?.length === 0) window.localStorage.removeItem("cartId");
        setCarts(carts?.filter(obj => moment().diff(moment(obj?.booking?.flightBooking?.at(0)?.destinations?.at(-1)?.departureDate),'days') < 1 && (obj?.booking?.account || user?._id))?.map((obj) => templateFlightCart(obj)));
      }
    
      function clearCart() {
        window.localStorage.setItem('flightCart','[]')
        navigate('/')
      }
    
  return (
    <div className='flex justify-center py-4 bg-primary/5 h-full flex-1'>
      <div className='sm:min-w-[800px] flex flex-col gap-4'>
        <div className='flex items-center gap-4 bg-theme1/10 px-4 py-2 rounded-md'>
            <div className='flex-1'>
                {status !== 'payed' ? 
                    'Your reservation is complete and awaiting payment'
                :
                    'Your reservation was successful. We will email your ticket once it\'s confirmed by the airline.'
                }
            </div>
            {status !== 'payed' ? 
                <div className='flex flex-col'>
                    <sm>Time Left:</sm>
                    <ExpiryTimeCounter targetDate={expiry}>
                        <TimeCount />
                    </ExpiryTimeCounter>
                </div>
            :null}
        </div>
        <div>
            <Passengers order={lastBooking} />
        </div>
        <PriceDisplay list={carts}/>
        <div className='flex justify-center p-4'>
            <div className='sm:min-w-[200px]'>
                <Button1 onClick={clearCart}>Continue</Button1>
            </div>
        </div>
      </div>
    </div>
  )
}

function PriceDisplay({list}) {
    const [data,setData] = useState({
        orderTotal: 0,
        Flight: 0,
        Tax: 0,
        Commission: 0,
        ticketingFee: 0,
        payable: 0,
    })

    useEffect(() => {
        calculatePrice()
    },[list])

    function calculatePrice() {
        let price = {
            orderTotal: 0,
            Flight: 0,
            Tax: 0,
            Commission: 0,
            ticketingFee: 0,
            payable: 0,
        }

        list?.map(obj => {
            const order = obj?.booking?.flightBooking?.at(0);

            // price.orderTotal += order?.grandTotal || 0
            price.Tax = getNumber(order?.grandTotal) - getNumber(order?.basePrice)
            // price.Tax = getNumber(order?.adult?.taxes || 0) + getNumber(order?.child?.taxes || 0) + getNumber(order?.infant?.taxes || 0)
            
            // price.Flight += order?.basePrice || 0
            price.Flight += order?.customerPayable || 0
            // price.ticketingFee += order?.ticketingFee || 0
            // price.Commission += (order?.customerPayable || 0) - (order?.payable || 0)

            
            return price;
        })
        price.payable = price.Flight
        
        console.log(price)
        
        price.orderTotal = price.Flight + price.ticketingFee + price.Commission;
        price.Flight = price.Flight - price.Tax

        setData(price)
    }
    
    return (
        <div className='card flex flex-col gap-2 shadow-md p-4'>
            <div className='flex gap-4 justify-between'>
                <b>Order Total</b>
                <b>{formatMoney(data?.orderTotal)}</b>
            </div>
            <div className='flex gap-4 justify-between'>
                <div>Flight</div>
                <div>{formatMoney(data?.Flight)}</div>
            </div>
            <div className='flex gap-4 justify-between'>
                <div>Tax</div>
                <div>{formatMoney(data?.Tax)}</div>
            </div>
            {/* <div className='flex gap-4 justify-between'>
                <div>Commission</div>
                <div>{formatMoney(data?.Commission)}</div>
            </div> */}
            {/* <div className='flex gap-4 justify-between'>
                <div>Ticketinge Fee</div>
                <div>{formatMoney(data?.ticketingFee)}</div>
            </div> */}
            <hr />
            <div className='flex gap-4 justify-between'>
                <b>Payable</b>
                <b>{formatMoney(data?.payable)}</b>
            </div>
        </div>
    )
}

function TimeCount() {
    const { time } = useContext(ExpiryTimeContext) || {};
        
    return (
        <b className='min-w-[120px]'>{time}</b>
    )
}